import type { TripDetail, TripSummary, ResolvedTripDates } from '../../types';

export function resolveDates(
  trip: Pick<TripDetail | TripSummary, 'lockStartDate' | 'lockEndDate'> &
    Partial<Pick<TripDetail, 'derivedStartDate' | 'derivedEndDate'>>
): ResolvedTripDates {
  if (trip.lockStartDate) {
    return {
      start: trip.lockStartDate,
      end: trip.lockEndDate,
      source: 'locked',
    };
  }
  const derivedStart = (trip as TripDetail).derivedStartDate ?? null;
  const derivedEnd = (trip as TripDetail).derivedEndDate ?? null;
  if (derivedStart) {
    return {
      start: derivedStart,
      end: derivedEnd,
      source: 'itinerary',
    };
  }
  return {
    start: null,
    end: null,
    source: 'none',
  };
}
